import React, { useState } from "react";
import { Navigate } from "react-router-dom";

const SeferPetachProvider = ({ children }) => {
  const [token] = useState(localStorage.getItem("Tolkien"));

  if (!token) {
    return (
      <Navigate to="/" replace />
    );
  }
  else {
    return (
      <>
        {children}
      </>
    );
  }
};
export { SeferPetachProvider };